import { CATEGORY } from '../../features/category/router/enums/category';
import { ARTICLE } from '../../features/article/router/enums/article';
import { KEYWORD } from '../../features/keyword/router/enums/keyword';
import { MULTIMEDIA } from '../../features/multimedia/router/enums/multimedia';
import { USERS } from '../../features/users/router/enums/usersEnum';

export const ROUTES = {
  FARMAPROM: 'https://moj.farmaprom.pl',
  DEFAULT: '/',
  ERROR_503: '/error/503',
  ERROR_404: '/error/404',
  ERROR_403: '/error/403',
  ERROR_401: '/error/401',
  DASHBOARD: '/dashboard',
  CATEGORY: CATEGORY,
  ARTICLE: ARTICLE,
  KEYWORD: KEYWORD,
  MULTIMEDIA: MULTIMEDIA,
  USERS: USERS,
};
